import { noopReturn, addUniqueItem } from '@motionone/utils';
import { getAnimationData } from '../data.es.js';

/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */
var axes = ["", "X", "Y", "Z"];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */
var order = ["translate", "scale", "rotate", "skew"];
var transformAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
};
var rotation = {
  syntax: "<angle>",
  initialValue: "0deg",
  toDefaultUnit: function toDefaultUnit(v) {
    return v + "deg";
  }
};
var baseTransformProperties = {
  translate: {
    syntax: "<length-percentage>",
    initialValue: "0px",
    toDefaultUnit: function toDefaultUnit(v) {
      return v + "px";
    }
  },
  rotate: rotation,
  scale: {
    syntax: "<number>",
    initialValue: 1,
    toDefaultUnit: noopReturn
  },
  skew: rotation
};
var transformDefinitions = new Map();
var asTransformCssVar = function asTransformCssVar(name) {
  return "--motion-".concat(name);
};
/**
 * Generate a list of every possible transform key
 */
var transforms = ["x", "y", "z"];
order.forEach(function (name) {
  axes.forEach(function (axis) {
    transforms.push(name + axis);
    transformDefinitions.set(asTransformCssVar(name + axis), baseTransformProperties[name]);
  });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
var compareTransformOrder = function compareTransformOrder(a, b) {
  return transforms.indexOf(a) - transforms.indexOf(b);
};
/**
 * Provide a quick way to check if a string is the name of a transform
 */
var transformLookup = new Set(transforms);
var isTransform = function isTransform(name) {
  return transformLookup.has(name);
};
var addTransformToElement = function addTransformToElement(element, name) {
  // Map x to translateX etc
  if (transformAlias[name]) name = transformAlias[name];
  var _getAnimationData = getAnimationData(element),
    transforms = _getAnimationData.transforms;
  addUniqueItem(transforms, name);
  /**
   * TODO: An optimisation here could be to cache the transform in element data
   * and only update if this has changed.
   */
  element.style.transform = buildTransformTemplate(transforms);
};
var buildTransformTemplate = function buildTransformTemplate(transforms) {
  return transforms.sort(compareTransformOrder).reduce(transformListToString, "").trim();
};
var transformListToString = function transformListToString(template, name) {
  return "".concat(template, " ").concat(name, "(var(").concat(asTransformCssVar(name), "))");
};
export { addTransformToElement, asTransformCssVar, axes, buildTransformTemplate, compareTransformOrder, isTransform, transformAlias, transformDefinitions };